module.exports = __webpack_public_path__ + "static/cmdnewpic-d54fe13e4d207d74e5192a3c0aee2245.jpg";